import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPeepLabelOptions as GetPeepLabelOptionsQuery,
    PeepLabelOptionsFragment,
} from 'nutshell-graphql-types';

import GET_PEEP_LABEL_OPTIONS from '../queries/get-peep-label-options.graphql';

export function useGetPeepLabelOptions(): {
    peepLabelOptions: PeepLabelOptionsFragment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetPeepLabelOptionsQuery,
        Record<string, unknown>
    >(GET_PEEP_LABEL_OPTIONS, {
        fetchPolicy: 'cache-first',
    });

    return {
        peepLabelOptions: data?.peepLabelOptions,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
